import { FC } from 'react';
import clsx from 'clsx';
import { Icon } from '@namespace/icons2';
import { AText } from '../AText';
import { Box } from '../Box';
import { Button } from '../Button';

import styles from './index.module.css';

interface NotificationProps {
  message: string | JSX.Element;
  buttonLabel?: string;
  onClick?: () => void;
  onClose?: () => void;
  className?: string;
}

export const Notification: FC<NotificationProps> = ({
  message,
  buttonLabel = '',
  onClick,
  onClose,
  className = ''
}) => {
  return (
    <Box
      align="center"
      justify="center"
      className={clsx(styles.notification, className)}
    >
      <Box align="center">
        <AText
          breed="R"
          size="l"
          color="notification_txt_color_1"
          className={styles.message}
        >
          {message}
        </AText>
        {buttonLabel && (
          <Button
            size="s"
            intent="secondary"
            actionType="color4"
            onClick={onClick}
            className={styles.button}
          >
            {buttonLabel}
          </Button>
        )}
      </Box>
      {onClose && (
        <Icon
          onClick={onClose}
          size="s"
          name="icons/general/action/close"
          className={styles.closeIcon}
        />
      )}
    </Box>
  );
};
